import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, CheckCircle2, Headphones, Gift, ChevronDown, ChevronUp, Tag } from 'lucide-react';
import { trackEvent } from '../utils/fbpixel';
export function PricingCTA() {
  const [showBonosDetails, setShowBonosDetails] = useState(false);
  return <section id="pricing" className="py-16 px-4 bg-matrix-bg relative overflow-hidden" data-id="element-174">
      {/* Background glow behind pricing */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-matrix-primary/5 blur-[100px] rounded-full pointer-events-none" data-id="element-175" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-177">
          <h2 className="text-3xl md:text-5xl font-black text-matrix-orange mb-8" data-id="element-178">
            Tu primera decisión
            <br data-id="element-179" />
            <span className="text-matrix-muted text-2xl md:text-3xl font-normal" data-id="element-180">
              (la que cambia todo)
            </span>
          </h2>

          <div className="space-y-6 text-xl text-matrix-muted mb-12" data-id="element-181">
            <p data-id="element-182">No es comprar.</p>
            <p data-id="element-183">
              Es elegir un{' '}
              <span className="text-matrix-orange font-semibold" data-id="element-184">umbral</span>.
            </p>
            <p data-id="element-185">Cama. Mesa. Baño. Escritorio.</p>
            <p className="font-bold text-matrix-text" data-id="element-186">Uno.</p>
            <p className="text-2xl md:text-3xl text-matrix-primary font-bold pt-4 text-glow" data-id="element-187">
              Cuando proteges un umbral, dejas de vivir como invitado en tu
              mente.
            </p>
          </div>

          {/* Pricing Card */}
          <div className="bg-matrix-surface border border-matrix-primary/30 p-10 rounded-xl max-w-md mx-auto shadow-[0_0_30px_rgba(0,255,65,0.1)] relative overflow-hidden" data-id="element-188">
            {/* OFERTA LIMITADA tag */}
            <div className="absolute top-4 right-[-34px] z-20 rotate-45 bg-matrix-red px-10 py-1 shadow-lg" data-id="element-189">
              <span className="text-white text-[10px] font-black uppercase tracking-wider flex items-center gap-1" data-id="element-190">
                OFERTA LIMITADA
              </span>
            </div>

            <div className="mb-6" data-id="element-191">
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-192">
                <span className="text-2xl text-matrix-muted line-through font-medium" data-id="element-193">
                  $97
                </span>
                <span className="bg-matrix-red/90 text-white text-xs font-black px-2 py-0.5 rounded" data-id="element-194">
                  82% OFF
                </span>
              </div>
              <span className="text-6xl font-black text-matrix-primary tracking-tight" data-id="element-195">
                $17.89
              </span>
              <p className="text-matrix-muted mt-2" data-id="element-196">Todo incluido</p>
            </div>

            {/* What's included checklist */}
            <div className="text-left mb-8 bg-matrix-red/5 border border-matrix-red/30 rounded-lg p-4 relative" data-id="element-197">
              <p className="text-matrix-red text-xs font-black uppercase tracking-widest mb-3 flex items-center gap-2" data-id="element-198">
                <span className="w-1.5 h-1.5 rounded-full bg-matrix-red animate-pulse" data-id="element-199" />
                TODO ESTO INCLUIDO POR $17.89:
              </p>
              <div className="space-y-3" data-id="element-200">
                {['Audiobook completo (1 hora, 14 tracks)', 'PDF Libro Digital', 'Workbook + Tracker 30 días'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-201">
                    <CheckCircle2 className="w-5 h-5 text-matrix-red shrink-0" data-id="element-202" />
                    <span className="text-matrix-text text-sm font-bold" data-id="element-203">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Mini Bonos Section */}
            <div className="mb-6 bg-matrix-bg/50 border border-matrix-orange/20 rounded-lg overflow-hidden text-left" data-id="element-204">
              <div className="p-4 border-b border-matrix-orange/10 bg-matrix-orange/5" data-id="element-205">
                <div className="flex items-center gap-2 mb-3" data-id="element-206">
                  <Gift className="w-4 h-4 text-matrix-orange" data-id="element-207" />
                  <p className="text-matrix-orange text-xs font-bold uppercase tracking-wide" data-id="element-208">
                    Bonos incluidos GRATIS (Valor $110):
                  </p>
                </div>
                <div className="space-y-3" data-id="element-209">
                  <div className="flex items-center gap-3" data-id="element-210">
                    <img src="https://cdn.magicpatterns.com/uploads/tWATLzc47etq2YS2oBkeMH/workbook.png" alt="Workbook + Tracker" className="w-12 h-12 rounded object-cover border border-matrix-primary/20 shrink-0" data-id="element-211" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-212">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-213">
                        <CheckCircle2 className="w-3 h-3 text-matrix-primary" data-id="element-214" />{' '}
                        Workbook + Tracker
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-215">
                        $59
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-216">
                    <img src="https://cdn.magicpatterns.com/uploads/gFwfkgkMbQ5ozoQ7BAcT2r/libro_digital_version.png" alt="Libro Digital" className="w-12 h-12 rounded object-cover border border-matrix-primary/20 shrink-0" data-id="element-217" />
                    <div className="flex-1 flex justify-between items-center" data-id="element-218">
                      <span className="text-matrix-text/90 text-sm flex items-center gap-2" data-id="element-219">
                        <CheckCircle2 className="w-3 h-3 text-matrix-primary" data-id="element-220" />{' '}
                        Libro Digital
                      </span>
                      <span className="text-matrix-muted line-through text-xs" data-id="element-221">
                        $51
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-4 py-2 bg-matrix-bg/80" data-id="element-222">
                <AnimatePresence data-id="element-223">
                  {showBonosDetails && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} className="overflow-hidden" data-id="element-224">
                      <div className="pt-2 pb-3 text-xs text-matrix-muted space-y-2 border-b border-matrix-dim mb-2" data-id="element-225">
                        <p data-id="element-226">
                          <strong className="text-matrix-text" data-id="element-227">
                            Workbook:
                          </strong>{' '}
                          Tablero de 30 días con contrato, tracker y checklist
                          semanal.
                        </p>
                        <p data-id="element-228">
                          <strong className="text-matrix-text" data-id="element-229">
                            Libro Digital:
                          </strong>{' '}
                          Versión texto completa para releer y subrayar.
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>

                <button onClick={() => setShowBonosDetails(!showBonosDetails)} className="w-full flex items-center justify-center gap-1 text-xs text-matrix-primary hover:text-matrix-secondary transition-colors py-1" data-id="element-230">
                  {showBonosDetails ? 'Leer menos' : 'Leer más'}
                  {showBonosDetails ? <ChevronUp className="w-3 h-3" data-id="element-231" /> : <ChevronDown className="w-3 h-3" data-id="element-232" />}
                </button>
              </div>
            </div>

            {/* Mini Audio Preview */}
            <div className="mb-6 bg-matrix-bg/80 border border-matrix-primary/20 rounded-lg overflow-hidden" data-id="element-233">
              <div className="flex items-center gap-2 px-3 py-2 border-b border-matrix-primary/10" data-id="element-234">
                <Headphones className="w-3.5 h-3.5 text-matrix-primary" data-id="element-235" />
                <p className="text-matrix-primary text-[10px] font-matrix tracking-widest uppercase" data-id="element-236">
                  {'>'} Escucha antes de comprar
                </p>
              </div>
              <div className="w-full bg-black/60 relative" style={{
              height: '60px'
            }} data-id="element-237">
                <iframe src="https://drive.google.com/file/d/1K2EJHFjXpSBzMz3LvpNggpnf0qX7fVo4/preview" width="100%" height="60" allow="autoplay" style={{
                border: 'none'
              }} title="Mente Maestra - Preview" data-id="element-238" />
                <div className="absolute top-0 right-0 w-12 h-12 bg-matrix-bg pointer-events-auto z-10" data-id="element-239" />
              </div>
            </div>

            <motion.a href="https://www.mellowreset.com/cart/42986204659778:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            trackEvent('InitiateCheckout', {
              content_name: 'Mente Maestra',
              content_ids: ['42986204659778'],
              content_type: 'product',
              value: 17.89,
              currency: 'USD'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full py-4 bg-matrix-primary text-matrix-bg font-bold text-xl rounded-sm hover:bg-matrix-secondary transition-colors shadow-[0_0_20px_rgba(0,255,65,0.4)] animate-pulse-glow flex items-center justify-center gap-2" data-id="element-240">
              Haz tu reset
              <ArrowRight className="w-6 h-6" data-id="element-241" />
            </motion.a>

            <p className="text-matrix-text font-medium" data-id="element-242">
              Empieza con el Track 1 hoy.
            </p>
          </div>

          <p className="mt-12 text-matrix-muted italic" data-id="element-243">
            no estás buscando perfección. Estás entrenando regreso.
          </p>
        </motion.div>
      </div>
    </section>;
}